module.exports = __webpack_public_path__ + "static/media/FrutosSilvestres_750.d573c5e2.jpg";